import React from 'react'
import contactBanner from "../../Assets/images/banner.jpg";
import { MdKeyboardArrowRight } from 'react-icons/md';
import { Link } from 'react-router-dom';


const ContactBanner = () => {
    return (
        <>
            <div className="aon-page-benner-area">
                <div
                    className="aon-page-banner-row"
                    style={{
                        backgroundImage: `url(${contactBanner})`, backgroundSize: 'cover',
                        height: 'fit-content',
                    }}
                >
                    <div
                        className="sf-overlay-main"
                        style={{ opacity: "0.8", backgroundColor: "#022279" }}
                    />
                    <div className="sf-banner-heading-wrap">
                        <div className="sf-banner-heading-area">
                            <div className="sf-banner-heading-large">Contact Us</div>
                            <div className="sf-banner-breadcrumbs-nav">
                                <ul className="list-inline">
                                    <ul className="list-inline">
                                        <Link to="/" className='text-decoration-none text-white'>Home
                                            <MdKeyboardArrowRight className='mx-1' />
                                        </Link>
                                        <Link to="/contact-us" className='text-decoration-none text-white '>Contact US</Link>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ContactBanner